<h2 class="str-title">
    <str-textual-display ...(input || {}) />
</h2>
